import { client } from '@platform/http/api-client';

// Per-account "recently viewed work items" history. Backed by the main app
// Postgres via the recently-viewed module (see server/). Scoped to the
// authenticated account server-side, so no account id is sent from here.
// Bumped whenever a new view is recorded, so the search-bar dropdown knows its
// cached recent list is stale and refetches on next open (instead of only after
// a full page reload).
let _invalidatedAt = 0;

const recentlyViewedApi = {
  // Fire-and-forget: record that the current account just viewed `key`.
  async recordRecentlyViewed(key) {
    const response = await client.post('/api/recently-viewed', { key });
    _invalidatedAt = Date.now();
    return response.data;
  },

  // Timestamp of the last recorded view — the search bar compares this against
  // its cache timestamp to decide whether to refetch.
  recentlyViewedInvalidatedAt() {
    return _invalidatedAt;
  },

  // Returns the account's recently-viewed issue keys, newest-viewed first.
  async getRecentlyViewed() {
    const response = await client.get('/api/recently-viewed');
    return response.data?.keys || [];
  },

  // Returns the account's recently-viewed items already resolved to
  // display-ready, Jira-shaped issues (newest-viewed first). One round-trip,
  // and the server skips the heavy per-issue loads the dropdown never shows.
  // Empty array when the account has no history yet (caller may fall back).
  async getRecentlyViewedItems() {
    const response = await client.get('/api/recently-viewed/items');
    return response.data?.items || [];
  },
};

export default recentlyViewedApi;
